import React, { useEffect, useState } from "react";
import withReactContent from "sweetalert2-react-content";
import Swal from "sweetalert2";
import CommonMaterialReactTable from "../../MaterialReactTable/CommonMaterialReactTable";
import apiHandler from "../../common/api";
import { Box } from "@mui/material";
import "sweetalert2/dist/sweetalert2.min.css";
import HeaderModule from "../../components/Header/HeaderModule";
import { useCheckUserPermission } from "../../common/userPermission";
import { dateFormat } from "../../common/common";
import { useSelector } from "react-redux";

const businessRequestDelete = "businessRequestDelete";
const businessRequestApprove = "businessRequestApprove";

const BusinessRegisterRequest = () => {
  const [productlist, setProductlist] = useState([]);
  const [deletes, setdelete] = useState(false);
  const MySwal = withReactContent(Swal);

  const user_data = useSelector((state) => state.user_data);

  const showConfirmationAlert = (id, type) => {
    MySwal.fire({
      title: "Are you sure?",
      text:
        type === "Reject"
          ? "You want to Reject this Business? \n You won't be able to revert this!"
          : "You want to Approve this Business?",
      showCancelButton: true,
      confirmButtonColor: "#00ff00",
      confirmButtonText: `Yes, ${type} it!`,
      cancelButtonColor: "#ff0000",
      cancelButtonText: "Cancel",
    }).then((result) => {
      if (result.isConfirmed) {
        showLoadingAlert(type); // Show loader while deleting
        if (type === "Reject") {
          handleDelete(id);
        } else {
          handleApprove(id);
        }
      }
    });
  };

  const showLoadingAlert = (type) => {
    MySwal.fire({
      title: type == "Reject" ? "Deleting..." : "Approving...",
      text: "Please wait while we process your request.",
      allowOutsideClick: false,
      didOpen: () => {
        MySwal.showLoading(); // Show loading spinner
      },
    });
  };

 const handleApprove = async (id) => {
  let reqobj = {
    ID: id,
    loginUserId: user_data?.id || 0,
  };

  try {
    const response = await apiHandler({
      method: "POST",
      route: "Superadmin/businessRequestApprove",
      payload: reqobj,
    });

    console.log(response, "dsncjndcndjcdnjnc")
    if (response?.ResponseID[0]?.ID == 0 && response.ResponseCode === "ERROR") {
      // Username already exists
      MySwal.fire({
        title: "Error!",
        text: "This business name is already exists. Please contact the business owner and do the needfull actions to select the other unique name.",
        icon: "error",
        confirmButtonText: "OK",
      });
    } else if (response.ResponseCode === "SUCCESS") {
      MySwal.fire({
        title: "Success!",
        text: "Your Request is successfully done.",
        icon: "success",
        confirmButtonText: "OK",
        customClass: {
          confirmButton: "btn btn-success",
        },
      });
      setdelete(!deletes);
    } else {
      MySwal.fire({
        title: "Error!",
        text: "Something went wrong. Please try again.",
        icon: "error",
        confirmButtonText: "OK",
      });
    }
  } catch (error) {
    MySwal.fire({
      title: "Error!",
      text: "An error occurred. Please try again later.",
      icon: "error",
      confirmButtonText: "OK",
    });
  }
};

  const handleDelete = async (id) => {
    let reqobj = {
      ID: id,
      Module: "businessOnboardRequest",
    };

    try {
      const response = await apiHandler({
        method: "POST",
        route: "Superadmin/permanentdeletebymoduleid",
        payload: reqobj,
      });

      if (response.ResponseCode === "SUCCESS") {
        MySwal.fire({
          title: "Deleted!",
          text: "Your business request has been rejected.",
          icon: "success",
          confirmButtonText: "OK",
          customClass: {
            confirmButton: "btn btn-success",
          },
        });
        setdelete(!deletes);
      } else {
        MySwal.fire({
          title: "Error!",
          text: "Something went wrong. Please try again.",
          icon: "error",
          confirmButtonText: "OK",
        });
      }
    } catch (error) {
      MySwal.fire({
        title: "Error!",
        text: "An error occurred. Please try again later.",
        icon: "error",
        confirmButtonText: "OK",
      });
    }
  };

  const columns = [
    {
      header: "ID",
      accessorKey: "id",
      enableSorting: true,
      sortingFn: "numeric",
      size: 100,
    },
    {
      header: "Business Name",
      accessorKey: "businessName",
      enableSorting: true,
      sortingFn: "alphanumeric",
    },
    {
      header: "Business Unique Name",
      accessorKey: "businessUniqueName",
      enableSorting: true,
      sortingFn: "alphanumeric",
    },
    {
      header: "Business Type",
      accessorKey: "businessTypeName",
      enableSorting: true,
      sortingFn: "alphanumeric",
    },
    {
      header: "Email",
      accessorKey: "emailAddress",
      enableSorting: true,
      sortingFn: "alphanumeric",
    },
    {
      header: "Address",
      accessorKey: "businessAddress",
      enableSorting: true,
      sortingFn: "alphanumeric",
    },
    {
      header: "City",
      accessorKey: "city",
      enableSorting: true,
      sortingFn: "alphanumeric",
    },
    {
      header: "Zipcode",
      accessorKey: "zipcode",
      enableSorting: true,
      sortingFn: "alphanumeric",
    },
    {
      header: "State",
      accessorKey: "state",
      enableSorting: true,
      sortingFn: "alphanumeric",
    },
    {
      header: "Country",
      accessorKey: "country",
      enableSorting: true,
      sortingFn: "alphanumeric",
    },
    {
      header: "Approved/Pending",
      accessorKey: "isApproved",
      enableSorting: true,
      Cell: ({ row }) =>
        row.original.isApproved == 1 ? "Approved" : "Pending",
    },
    {
      header: "Created On",
      accessorKey: "createdAt",
      enableSorting: true,
      sortingFn: "alphanumeric",
      Cell: ({ row }) => dateFormat(row.original.createdAt),
    },
    {
      accessorKey: "actions",
      header: "Actions",
      enableSorting: false,
      enableColumnFilter: false,
      //   size: 120,
      Cell: ({ row }) => {
        const canApprove = useCheckUserPermission(businessRequestApprove);
        const canReject = useCheckUserPermission(businessRequestDelete);

        return (
          <Box sx={{ display: "flex" }}>
            {row.original.isApproved == 0 && (
              <>
                <Box sx={{ display: "flex", gap: "0.5rem" }}>
                  {canApprove && (
                    <button
                      className="btn btn-outline-primary btn-sm me-2"
                      onClick={() => {
                        showConfirmationAlert(row.original.id, "Approve");
                      }}
                    >
                      Approve
                    </button>
                  )}
                </Box>
                <Box sx={{ display: "flex", gap: "0.5rem" }}>
                  {canReject && (
                    <button
                      className="btn btn-outline-primary btn-sm me-2"
                      onClick={() => {
                        showConfirmationAlert(row.original.id, "Reject");
                      }}
                    >
                      Reject
                    </button>
                  )}
                </Box>
              </>
            )}
          </Box>
        );
      },
    },
  ];

  const prodcutDataListApi = async () => {
    const response = await apiHandler({
      method: "GET",
      route: `Superadmin/businessonboardrequestlist`,
    });
    if (response.ResponseCode === "SUCCESS") {
      console.log(response, "data");
      setProductlist(response.ResponseData);
    } else {
      console.log(response, "data");
    }
  };

  useEffect(() => {
    prodcutDataListApi();
  }, [deletes]);

  const exportData = productlist.map((item) => ({
    ID: item?.id,
    Name: item?.name,
    Email: item?.email,
    Contact: item?.contact,
    Details: item?.extra,
    ["Created On"]: dateFormat(item?.createdAt),
  }));

  return (
    <div className="page-wrapper">
      <div className="content">
        <HeaderModule
          refreshData={prodcutDataListApi}
          exportData={exportData}
        />
        {/* /product list */}
        <div className="card table-list-card">
          <div className="card-body">
            <div className="table-responsive">
              <CommonMaterialReactTable
                columns={columns}
                data={productlist}
                columnRightPin={["actions"]}
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default BusinessRegisterRequest;
